import {obieApi} from 'lib/obie/url'
import {useOrganizationObieClient} from 'lib/obie/use-organization-obie-client'
import {useOrganization} from 'organization/OrganizationProvider'
import {useMutation, useQueryClient} from 'react-query'

export function useUpdateAssistantThread() {
  const {client} = useOrganizationObieClient()
  const qc = useQueryClient()
  const {organization} = useOrganization()

  return useMutation({
    mutationFn: async (data: {
      id: number
      assistant_id: number
      title: string
    }) => {
      const {id, title} = data

      return client!.put(
        obieApi(`/organizations/${organization.id}/assistant_threads/${id}`),
        {title},
      )
    },
    onSuccess: (_, data) => {
      qc.invalidateQueries([
        'organizations',
        organization.id,
        'assistant_threads',
        data.id,
      ])

      qc.invalidateQueries([
        'organizations',
        organization.id,
        'assistants',
        data.assistant_id,
      ])
    },
  })
}
